// extracted by mini-css-extract-plugin
export default {"referenceItem":"CardChart_referenceItem__eViXu","referenceDot":"CardChart_referenceDot__Kazb1","referenceLabel":"CardChart_referenceLabel__H6Bzn"};